// extracted by mini-css-extract-plugin
export var cardContainer = "_nh-0";
export var cardHeader = "_nh-2";
export var collapsedState = "_nh-3";
export var dragHandle = "_nh-5";
export var dragHandleIcon = "_nh-6";
export var dragging = "_nh-1";
export var titleArea = "_nh-4";